import React, { useEffect } from 'react';
import { CircularProgress, Backdrop } from '@mui/material';

export const GlobalLoader = ({ isVisible, onHide }) => {
	useEffect(() => {
		if (isVisible) {
			// Auto hide loader after 10 seconds to handle errors or slow loading
			const timeout = setTimeout(() => {
				onHide();
			}, 10000);

			// Also hide on page visibility change (when user navigates away/back)
			const handleVisibilityChange = () => {
				if (document.visibilityState === 'visible') {
					onHide();
				}
			};

			document.addEventListener('visibilitychange', handleVisibilityChange);

			return () => {
				clearTimeout(timeout);
				document.removeEventListener(
					'visibilitychange',
					handleVisibilityChange
				);
			};
		}
	}, [isVisible, onHide]);

	if (!isVisible) return null;

	return (
		<Backdrop
			open={true}
			sx={{
				zIndex: (theme) => theme.zIndex.modal + 999,
				color: '#00BFFF',
				backgroundColor: 'rgba(0, 0, 0, 0.5)',
			}}
		>
			<CircularProgress
				thickness={4}
				size={48}
				sx={{
					color: '#00BFFF',
				}}
			/>
		</Backdrop>
	);
};
